import { usePage } from "@inertiajs/react"
import { Navigation } from "app/navigation"
import React, { useEffect } from "react"
import { LayoutBanners } from "./layout-banners"
import {
  reportAndReload,
  clearLayoutReloadGuard
} from "./layout-config-sentry-context"

class InertiaPageHeaderErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch(error, info) {
    const reloading = reportAndReload(error, info, this.props.pageContext)
    if (!reloading) {
      this.setState({ hasError: true })
    }
  }

  render() {
    if (this.state.hasError) return <InertiaPageHeaderErrorFallback />
    return this.props.children
  }
}

function InertiaPageHeaderErrorFallback() {
  return (
    <div className="alert alert-warning m-0" role="alert">
      Couldn&apos;t load navigation. Try refreshing the page.
    </div>
  )
}

export function InertiaPageHeader() {
  const page = usePage()
  const {
    props: { layoutConfig }
  } = page

  const pageContext = {
    layoutConfig,
    url: page.url,
    component: page.component,
    version: page.version
  }

  return (
    <InertiaPageHeaderErrorBoundary pageContext={pageContext}>
      <InertiaPageHeaderContent layoutConfig={layoutConfig} />
    </InertiaPageHeaderErrorBoundary>
  )
}

function InertiaPageHeaderContent({ layoutConfig }) {
  useEffect(() => {
    clearLayoutReloadGuard()
  }, [])

  return (
    <>
      {layoutConfig.components.navbar.visible && (
        <Navigation {...layoutConfig.components.navbar.data} />
      )}

      <LayoutBanners layoutConfig={layoutConfig} />
    </>
  )
}
